/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbResultatTypeEvaluationGridDto } from './FcbResultatTypeEvaluationGridDto';
import {
    FcbResultatTypeEvaluationGridDtoFromJSON,
    FcbResultatTypeEvaluationGridDtoFromJSONTyped,
    FcbResultatTypeEvaluationGridDtoToJSON,
} from './FcbResultatTypeEvaluationGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbResultatTypeEvaluationGridDtoPaginatedResults
 */
export interface FcbResultatTypeEvaluationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbResultatTypeEvaluationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbResultatTypeEvaluationGridDto>}
     * @memberof FcbResultatTypeEvaluationGridDtoPaginatedResults
     */
    results?: Array<FcbResultatTypeEvaluationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbResultatTypeEvaluationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbResultatTypeEvaluationGridDtoPaginatedResults interface.
 */
export function instanceOfFcbResultatTypeEvaluationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbResultatTypeEvaluationGridDtoPaginatedResultsFromJSON(json: any): FcbResultatTypeEvaluationGridDtoPaginatedResults {
    return FcbResultatTypeEvaluationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbResultatTypeEvaluationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbResultatTypeEvaluationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbResultatTypeEvaluationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbResultatTypeEvaluationGridDtoPaginatedResultsToJSON(value?: FcbResultatTypeEvaluationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbResultatTypeEvaluationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

